"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskSVGDraw = void 0;
var mithril_1 = require("../mithril");
var theme_1 = require("../theme");
var MaskSVGDraw = /** @class */ (function () {
    function MaskSVGDraw() {
    }
    MaskSVGDraw.view = function (node, options, maskSvgObject) {
        var _a;
        if (!options.insightMaskTypesVisible) {
            return null;
        }
        if (maskSvgObject) {
            var svg_1 = maskSvgObject.svg;
            if (!svg_1) {
                return null;
            }
            // assume one group for each object type
            var detectionClassGroups = options.insightMaskTypesVisible.map(function (detectionClass) {
                return svg_1.g.find(function (g) { return g.id === detectionClass; });
            });
            //TODO: need to sort each shape by y position
            var detectionClassGroupShapes = detectionClassGroups.filter(Boolean).map(function (group) {
                if (!group) {
                    return null;
                }
                return group.g.map(function (item) {
                    return getShapes(item, group.id);
                });
            });
            return (0, mithril_1.m)('g', {
                className: theme_1.ClassNames.mask,
                id: "mask-".concat((_a = node.state) === null || _a === void 0 ? void 0 : _a.id)
            }, [detectionClassGroupShapes]);
        }
        else {
            return null;
        }
    };
    return MaskSVGDraw;
}());
exports.MaskSVGDraw = MaskSVGDraw;
function getShapes(item, type) {
    var _a, _b, _c, _d;
    var polylineNode = item.polyline
        ? (0, mithril_1.m)('polyline', {
            id: (_a = item.polyline) === null || _a === void 0 ? void 0 : _a.id,
            points: (_b = item.polyline) === null || _b === void 0 ? void 0 : _b.points,
            style: {
                'pointer-events': 'none'
            }
        })
        : null;
    var pathNode = item.path
        ? (0, mithril_1.m)('path', {
            id: (_c = item.path) === null || _c === void 0 ? void 0 : _c.id,
            d: (_d = item.path) === null || _d === void 0 ? void 0 : _d.d,
            style: {
                'pointer-events': 'none'
            }
        })
        : null;
    return (0, mithril_1.m)('g', {
        className: type,
        id: item.id
    }, [
        polylineNode,
        pathNode
    ]);
}
//# sourceMappingURL=mask.draw.svg.js.map